// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__3q72d","assignButton":"CreateEditEquipmentSchedule_assignButton__27nO8"};